import React, { useState, useMemo } from 'react';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SingleQuoteVersionDetails = () => {
  const { versionId } = useParams();
  const navigate = useNavigate();
  const { showToast } = React.useContext(ToastContext);

  const decodedId = versionId ? atob(versionId) : versionId;
  const id = decodedId.replace(/\D/g, '');

  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES['quoteVersion']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['quoteVersion'] + id + '/', { headers });
      showToast('Quote Version deleted successfully', 'success');
      navigate('/quote/version/list');
    } catch (error) {
      console.error('Error deleting Quote Version:', error);
      showToast('Error deleting Quote Version', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Quote Version"
        listPath="/quote/version/list"
        editPath={`/quote/version/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Quote Version"
        message="Are you sure you want to delete this Quote Version?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SingleQuoteVersionDetails;
